<h2 mat-dialog-title class="bg-primary !text-white">Are you sure you want to make this change?</h2>
<mat-dialog-content>
  <p class="pt-4">
    Are you sure you want to make this change? You will no longer have CA:
    <b> {{ data.caCustomDescription }} </b> attached to this order.
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end" class="gap-2 mt-4">
  <button mat-flat-button (click)="cancel()">Cancel</button>
  <button mat-flat-button color="warn" (click)="confirm()">Confirm</button>
</mat-dialog-actions>
